module.exports = "/fonts/fa-regular-400.ttf?6086b966f7072932f0943a9e01ab702e";